import { useEffect, useState } from 'react'
import { LmsOrder } from '../../models'
import { startSxpProxy } from '../../../../utils/api'
import { LABS_PROJECT_ID } from '../../../../utils/constants'
import Close from '../../../../assets/images/close.webp'
import { Box, Typography } from '@mui/material'
import { orderEventStatus } from '../../constants'
import { OrderEvent, OrderEventTests } from '../../../labTests/models'
import {
  readableDateFormat,
  readableDateTimeFormat,
} from '../../../../utils/dateUtils'

type SingleEventProps = {
  event: OrderEventTests
}

const SingleEvent = ({ event }: SingleEventProps) => {
  let status = ''
  switch (event?.status as string) {
    case 'ORDERED':
    case 'ORDER_MODIFIED':
      status = orderEventStatus?.ORDERED
      break
    case 'COLLECTED':
      status = orderEventStatus?.SAMPLE_COLLECTED
      break
    case 'LOC_ALLOCATED':
      status = orderEventStatus?.TEST_LOCATION_ALLOCATED
      break
    case 'COLLECTION_COMPLETED':
      status = orderEventStatus?.SAMPLE_COLLECTION_COMPLETED
      break
    case 'COLLECTION_APPROVED':
      status = orderEventStatus?.SAMPLES_APPROVED
      break
    case 'COLLECTION_REJECTED':
      status = orderEventStatus?.SAMPLES_REJECTED
      break
    case 'ENTERED':
      status = orderEventStatus?.RESULTS_ENTERED
      break
    case 'ENTERED_REFERRED':
      status = orderEventStatus?.REFERRED_RESULTS_ENTERED
      break
    case 'SUBMITTED':
      status = orderEventStatus?.RESULTS_SUBMITTED
      break
    case 'APPROVED':
      status = orderEventStatus?.RESULTS_APPROVED
      break
    case 'REJECTED':
      status = orderEventStatus?.RESULTS_REJECTED
      break
  }

  return (
    <div className='single-event'>
      <div className='event-left'>
        <p className='event-date'>
          {readableDateTimeFormat(new Date(event?.updatedOn))}
        </p>
        <p className='updated-by'>{event?.updatedBy}</p>
      </div>
      <div>
        <p>{status}</p>
      </div>
    </div>
  )
}

type Props = {
  order: LmsOrder
  onClose: () => void
}

const EventDialog = ({ order, onClose }: Props) => {
  const [loading, setLoading] = useState(true)
  const [events, setEvents] = useState<OrderEvent[]>([])

  useEffect(() => {
    const orderId = order.id
    startSxpProxy(LABS_PROJECT_ID, 'getOrderEventsByOrder', { orderId })
      .then((data) => {
        setEvents(data?.data?.order_event)
      })
      .catch((err) => {
        console.log(err)
        setEvents([])
      })
      .finally(() => {
        setLoading(false)
      })
  }, [order])

  return (
    <div className='event-dialog'>
      <span className='event-close' onClick={() => onClose()}>
        <img className='close-img' src={Close} alt='Close Event Dialog' />
      </span>

      <div className='event-header'>
        <Box display={'flex'} flexDirection={'column'} lineHeight={1.5}>
          <Box>
            <h2>Order ID: {order?.lr_number ?? order?.id}</h2>
          </Box>
          <Box>
            Ordered: {readableDateFormat(new Date(order?.ordered_on ?? ''))}
            {' - '}
            <span>{order?.source}</span>
          </Box>
        </Box>
        <div className='patient-details'>
          <Typography className='event-dialog-content'>
            {order?.patientName}
          </Typography>

          <p>{order?.patientUhid}</p>
        </div>
      </div>
      <div className='events'>
        {loading
          ? 'Loading...'
          : events?.[0]?.tests
              ?.sort(
                (a, b) =>
                  new Date(a?.updatedOn).getTime() -
                  new Date(b?.updatedOn).getTime()
              )
              ?.filter(
                (item, index, arr) =>
                  index === 0 || item?.updatedOn !== arr[index - 1]?.updatedOn
              )
              ?.map((e, index) => <SingleEvent event={e} key={index} />)}
      </div>
    </div>
  )
}

export default EventDialog
